import getKeySubstring from "features/shared/functions/getKeySubstring";
import { InfoAdapterType } from "features/shared/types/info";
import { Tag } from "features/shared/types/tag";

interface Props {
    fields: Tag;
    tags: Tag[];
    isUpdating?: boolean;
    isImporting?: boolean;
    originalFields?: Tag;
}

export const verifyForm = ({
    fields,
    tags,
    isUpdating,
    isImporting,
    originalFields,
}: Props) =>
    new Promise(
        (resolve: (res: string) => void, reject: (err: string) => void) => {
            const existingTag = tags.find((tag) => tag.key === fields.key);
            if (!isUpdating && !isImporting && existingTag)
                reject(`Key '${fields.key}' already exists`);
            if (
                isUpdating &&
                !isImporting &&
                fields.key !== originalFields?.key
            )
                reject("You cannot change the tag key");

            // eslint-disable-next-line

            if (!fields.key.trim()) reject("Key cannot be empty");

            if (fields.key.includes("/"))
                reject("Key cannot include '/' character");

            if (fields.key.includes(","))
                reject("Key cannot include ',' character");

            const splitKey: string[] = fields.key.split(":");
            if (!splitKey[0] || !splitKey[splitKey.length - 1])
                reject(`Key '${fields.key}' is in incorrect format`);

            if (
                !fields.value.type ||
                !Object.values(InfoAdapterType).includes(fields.value.type)
            )
                reject(
                    `Tag type for tag with key '${fields.key}' not provided or invalid`
                );

            const oldestAncestor = getKeySubstring(fields.key, 0);

            if (fields.value.type === InfoAdapterType.DefaultInfo) {
                const parentList = [
                    "category",
                    "application",
                    "process",
                    "supplier",
                ];
                if (!parentList.includes(oldestAncestor)) {
                    reject(
                        `First block of (default tag) key '${fields.key}' must be 'category', 'application', 'process', or 'supplier'`
                    );
                }
            }

            if (fields.value.type === InfoAdapterType.StringInfo) {
                if (oldestAncestor !== "custom") {
                    reject(
                        `First block of (custom tag) key '${fields.key}' must be 'custom'`
                    );
                }
            }

            resolve("Success");
        }
    );
